import { selectHasReadEntitiesPermissions } from 'app/modules/session/selectors';
import { useSelector } from 'react-redux';

import { U21Chip, U21ChipProps } from 'app/shared/u21-ui/components';
import { SidebarComponentTypes } from 'app/modules/sidebar/models';
import {
  useToggleEntitySidebar,
  useToggleSidebar,
} from 'app/modules/sidebar/hooks';
import { omit } from 'lodash';
import { IconUser } from '@u21/tabler-icons';

export type U21EntityChipProps = (
  | EntityByExternalIDProps
  | EntityByU21IDProps
) &
  Omit<U21ChipProps, 'id' | 'name' | 'children'>;

interface EntityByExternalIDProps {
  externalId: string;
  name: string;
}

interface EntityByU21IDProps {
  id: number | string;
  name: string;
  // Optional external id. When provided alongside the unit21 id, it is forwarded
  // to the sidebar so the entity resolves in PG cache mode (hashed-id lookup)
  // while still working via the unit21 id in non-cache mode.
  externalId?: string;
}

export const U21EntityChip = (props: U21EntityChipProps) => {
  const { name, ...rest } = props;

  const propsWithoutIds = omit(rest, ['externalId', 'id']); // Needed to prevent typescript error

  const hasReadEntitiesPermission = useSelector(
    selectHasReadEntitiesPermissions,
  );
  const toggleSidebar = useToggleSidebar();
  const toggleEntitySidebar = useToggleEntitySidebar();
  return (
    <U21Chip
      onClick={
        hasReadEntitiesPermission
          ? (e) => {
              e.stopPropagation();
              if ('id' in props) {
                const { id, externalId } = props;
                toggleEntitySidebar(
                  id,
                  e,
                  externalId ? { externalId } : undefined,
                );
              } else {
                const { externalId } = props;
                toggleSidebar(
                  '', // TODO sc-81031 support cmd+click for entities by external id
                  {
                    type: SidebarComponentTypes.ENTITY,
                    data: {
                      id: '',
                      externalId,
                    },
                  },
                  e,
                );
              }
            }
          : undefined
      }
      icon={<IconUser />}
      {...(propsWithoutIds as Omit<U21EntityChipProps, 'id' | 'name'>)}
    >
      {name}
    </U21Chip>
  );
};
